import HandleResponsesV2 from '@common/utils/handleApiResponsesV2';
import axios from '@/axios';
import tmsMdmAxiosInstance from '@/tms-mdm-axios';
import faker from './faker';

const fake = false;

const actions = {
  async filterInvoice({ commit }, filters) {
    try {
      let result = [];
      if (filters.page_number === 1) {
        commit('SET_LOADING', true);
      } else {
        commit('paginationCheck', true);
      }
      if (fake) {
        result = await new Promise(resolve => setTimeout(() => resolve(faker.invoicelist), 500));
        commit('SET_LIST_INVOICE', result);
      } else {
        const params = filters;
        result = await axios('/v2/shipper/invoice', { params });
        commit('SET_LIST_INVOICE', result);
      }
      return result.data;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    } finally {
      commit('paginationCheck', false);
      commit('SET_LOADING', false);
    }
  },

  async filterPayIndents({ commit }, filters) {
    try {
      let result = [];
      if (filters.page_number === 1) {
        commit('SET_LOADING', true);
      } else {
        commit('paginationCheck', true);
      }
      if (fake) {
        result = await new Promise(resolve => setTimeout(() => resolve(faker.invoicelist), 500));
        commit('SET_LIST', result.data);
      } else {
        const params = filters;
        result = await axios('/v2/shipper/payments/list', { params });
        commit('SET_LIST', result.data.payments);
      }
      return result.data;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    } finally {
      commit('paginationCheck', false);
      commit('SET_LOADING', false);
    }
  },

  async invoiceDetails(_, params) {
    try {
      let result = [];
      if (fake) {
        result = await new Promise(resolve => setTimeout(() => resolve(faker.invoiceDetail), 500));
      } else {
        result = await axios(`/v2/shipper/invoice/${params.invoiceId}/detail`);
      }
      return result.data;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async addInvoiceComment(_, params) {
    try {
      const result = await axios.post(`/v2/shipper/invoice/${params.invoiceId}/comment`,
        { data: {
          message: params.message,
          isReturnedComment: params.isReturnComment,
          isRejectedComment: params.isRejectComment,
        } });
      return result && result.data;
    } catch (error) {
      return false;
    }
  },

  async searchTransporter(_, params) {
    try {
      const result = await tmsMdmAxiosInstance('/transporter/names/list', { params });
      return result && result.data;
    } catch (error) {
      return false;
    }
  },
  async getInvoiceDetailMeta({ commit }, { invoiceId }) {
    try {
      // commit('SET_LOADING', true);
      let result = [];
      result = await axios(`/v2/shipper/invoice/${invoiceId}/meta`);
      if (result && result.meta) {
        commit('setInvoiceMeta', result.meta);
        const resultMetaMutations = {
          system_total: 'setTotalSystemCharges',
          transporter_total: 'setTotalTransporterCharges',
          transporter_freight: 'setTansporterTotalFreightCharge',
          freight_bill: 'setFreightBillDetails',
          is_attachment_available: 'setAttachmentAvailable',
        };
        const resultMetaKeys = Object.keys(resultMetaMutations);
        for (let i = 0; i < resultMetaKeys.length; i += 1) {
          const key = resultMetaKeys[i];
          commit(resultMetaMutations[key], result.meta[key]);
        }
        if (result.meta && result.meta.depot_details) {
          commit('setDepotDetails', result.meta);
        }
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    } finally {
      // commit('SET_LOADING', false);
    }
  },

  async getDepotWiseInvoiceDetail({ commit }, { invoiceId, params }) {
    try {
      const result = await axios(`/v2/shipper/invoice/${invoiceId}`, { params });
      if (result && result.data) {
        commit('setInvoiceDetails', { ...result, params });
        if (result.data.payments) {
          commit('updateDepotPagination', { ...params, payment_count: result.data.payments.length });
          commit('setIsDedicatedTruck', result);
        }
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },

  // DEPRICATED
  // async getInvoiceDetail({ commit }, { invoiceId, params }) {
  //   try {
  //     // commit('SET_LOADING', true);
  //     const result = await axios(`/v2/shipper/invoice/${invoiceId}`, { params });
  //     if (result && result.data) {
  //       commit('setIsDedicatedTruck', result);
  //       commit('setInvoiceDetails', result);
  //       if (result.data.freight_bill) {
  //         commit('setFreightBillDetails', result.data.freight_bill);
  //       }
  //     }
  //     return result;
  //   } catch (error) {
  //     return HandleResponsesV2.Status(error);
  //   } finally {
  //     // commit('SET_LOADING', false);
  //   }
  // },

  async getPaymentCharges(_, params) {
    try {
      const result = await axios(`/v2/shipper/invoice/charge/${params.payment_id}/${params.consignee_data_id}`);
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },

  async getIndentDetailsTimelines(_, params) {
    try {
      const result = await axios('/v2/shipper/indent_details', { params });
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },

  async updateCommentAttachment(_, { commentId, formData }) {
    try {
      const result = await axios.post(`/v2/shipper/payments/${commentId}/comment_attachments`,
        formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },


  async setInvoiceStatus(_, params) {
    try {
      let result = [];
      const invoiceId = params.invoiceId;
      const data = params;
      delete data.invoiceId;
      result = await axios.put(`/v2/shipper/invoice/${invoiceId}/status`, { data });
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async updateIndentStatus(_, { id }) {
    try {
      const result = await axios.put(`/v2/shipper/payments/${id}/updateIndentStatus`);
      return result.data;
    } catch (error) {
      return error;
    }
  },
  async uploadIndents(_, formData) {
    try {
      const result = await axios.put('/v2/shipper/payments/uploadPaymentExcel',
        formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      return result;
    } catch (error) {
      return error;
    }
  },

  async verifyInvoice(_, { invoiceId }) {
    try {
      const result = await axios.put(`/v2/shipper/invoice/verify/${invoiceId}`);
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },

  async mailAnnexure(_, params) {
    try {
      const result = await axios.get(`/v2/shipper/invoice/${params.invoiceId}/mailannexure`);
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },

  async updateAttachment(_, { paymentId, formData }) {
    try {
      const result = await axios.post(`/v2/shipper/payments/${paymentId}/indent_attachments`,
        formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },

  async deleteAttachment(_, { attachmentId }) {
    try {
      const result = await axios.delete(`/v2/shipper/payments/attachment/${attachmentId}/`);
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async updateComment(_, params) {
    try {
      const result = await axios.post(`/v2/shipper/payment/${params.id}/comment`,
        { data: params.data });
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async updateChargeComment(_, params) {
    try {
      const result = await axios.post(`/v2/shipper/payment/${params.id}/chargeComment`,
        { data: params.data });
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },

  async updateMultiIndent({ commit }, data) {
    try {
      const result = await axios.patch('/v2/shipper/payments/', { data });
      /* Adding success response constants */
      if (result && result.data === 'Success') {
        result.updates.payments.forEach(indentDetail =>
          commit('updateIndentDetails', indentDetail),
        );
      }
      return result.data;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },

  async updateIndent({ commit }, data) {
    try {
      const result = await axios.patch(`/v2/shipper/payments/${data.id}`, { data: data.data });
      /* Adding success response constants */
      if (result && result.data === 'Success') {
        commit('updatePayments', result.updates.payments[0]);
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },

  async getInvoicePaymentsList(_, params) {
    try {
      const result = await axios.get(`/v2/shipper/invoice/${params.invoiceId}`, { params });
      return result;
    } catch (error) {
      console.log(error);
      return HandleResponsesV2.Status(error);
    }
  },

  async invoiceExport(_, params) {
    try {
      const headers = { responseType: 'blob' };
      const result = await axios.post('v2/shipper/invoice/export', params, headers);
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },

  async invoiceExportAll(_, params) {
    try {
      const headers = { responseType: 'blob' };
      const result = await axios.post('v2/shipper/invoice/exportAll', params, headers);
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },

  async invoiceStatusUpdate(_, formData) {
    try {
      const result = await axios.put('/v2/shipper/invoice/update_status',
        formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },

  async cancelInvoices({ commit }, selectedInvoices) {
    try {
      const result = await axios.put('/v2/shipper/invoice/bulkInvoiceCancel',
        { data: selectedInvoices });
      if (result && result.data && result.data.length) {
        commit('cancelInvoices', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },

  async retryInvoicePosting({ commit }, params) {
    try {
      const { invoiceId } = params;
      const result = await axios.put(`/v2/shipper/invoice/${invoiceId}/retry_invoice_posting`);
      if (result && result.data && result.data.status === 'Success') {
        commit('updateRetryFreightInvoice', invoiceId);
      }
      return result && result.data;
    } catch (error) {
      return false;
    }
  },
  async exportFreightBill(_, params) {
    try {
      const result = await axios.get(`v2/shipper/invoice/${params.freightBillId}/freightBillexport`);
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async updateSignatureStatus({ commit }, params) {
    try {
      let result = [];
      const invoiceId = params.invoiceId;
      const data = params;
      delete data.invoiceId;
      result = await axios.put(`/v2/shipper/invoice/${invoiceId}/update_signature_status`, { data });
      if (result && result.data) {
        commit('updateSignatureStatus', { ...params, invoiceId });
      }
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },
  async updateCustomFields({ _ }, params) {
    try {
      let result = [];
      const invoiceId = params.invoiceId;
      const data = params;
      delete data.invoiceId;
      result = await axios.put(`/v2/shipper/invoice/${invoiceId}/update_custom_fields`, { data });
      return result;
    } catch (error) {
      return HandleResponsesV2.Status(error);
    }
  },

  async getIndentCharges({ commit }, { orderNo }) {
    commit('SET_FREIGHT_CHARGE_LOADING', true)
    try {
      const result = await axios.get(`/v2/shipper/payments/charges/${orderNo}`);
      return result;
    } catch (error) {
      return error;
    } finally{
      commit('SET_FREIGHT_CHARGE_LOADING', false)
    }
  },
};
export default actions;
